module.exports = __webpack_public_path__ + "img/L_321_324.caa05457.png";